var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-1046.000000, -28.000000)",
    fill: "#23293C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(540.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.756886,40.5837553 L517.06567,37.8931031 C517.88129,36.8256026 518.328619,35.5307879 518.328797,34.1644724 C518.328797,32.5179259 517.687382,30.9698197 516.522665,29.8055499 C515.358151,28.6412802 513.809923,28 512.162828,28 C510.515936,28 508.967505,28.6412801 507.802991,29.8055499 C505.399003,32.2092364 505.399003,36.1201134 507.802991,38.5233948 C508.967505,39.6878671 510.515936,40.3291472 512.162828,40.3291472 C513.52943,40.32897 514.824517,39.8817349 515.892241,39.0662852 L518.583458,41.7569374 C518.745331,41.9189791 518.957853,42 519.170172,42 C519.382491,42 519.595013,41.9189791 519.756886,41.7569374 C520.081038,41.4330565 520.081038,40.9076362 519.756886,40.5837553 Z M508.976419,37.3502127 C507.219519,35.5936804 507.219721,32.7354669 508.976419,30.978732 C509.82752,30.128013 510.959213,29.6593073 512.162828,29.6593073 C513.366646,29.6593073 514.498137,30.128013 515.349237,30.978732 C516.200337,31.8296536 516.669141,32.96111 516.669141,34.1644724 C516.669141,35.3680373 516.200337,36.4992911 515.349237,37.3502127 C514.498137,38.2011343 513.366646,38.66984 512.162828,38.66984 C510.959213,38.66984 509.82752,38.2011343 508.976419,37.3502127 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4cd07d2fc718374f40d32ced593c26cd.svg";
export { ForwardRef as ReactComponent };